if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {

      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;

      if ( this.nextButton ) {
        this.nextButton.addEventListener('click', ()=>{
          this.changeSlide('next');
        });
      }
      if ( this.prevButton ) {
        this.prevButton.addEventListener('click', ()=>{
          this.changeSlide('prev');
        });
      }

      // Auto-rotate every 4 seconds
      this.autoPlay = setInterval(() => {
        this.changeSlide('next');
      }, 4000);

    }

    changeSlide(direction) {

      // Remove disabled states — we now loop
      if ( this.nextButton ) this.nextButton.classList.remove('announcement-bar__content-nav--disabled');
      if ( this.prevButton ) this.prevButton.classList.remove('announcement-bar__content-nav--disabled');

      if ( direction == 'next' ) {
        this.index = (this.index + 1) % this.length;
      } else if ( direction == 'prev' ) {
        this.index = (this.index - 1 + this.length) % this.length;
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });

    }

  }

  if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

}